import {
  Component,
  Input,
  OnInit,
  inject,
  input,
  output,
  ChangeDetectionStrategy,
} from "@angular/core";
import { Subscription } from "rxjs";
import { SelectItem } from "primeng/api";
import { OrganizationRepository } from "../../../organization/organization.repository";
import { Organization } from "../../../organization/organization.model";
import { Bind } from "primeng/bind";
import { Select } from "primeng/select";
import { FormsModule } from "@angular/forms";

export interface OrganizationChangeEvent {
  originalEvent: MouseEvent;
  value: Organization;
}

@Component({
  selector: "app-organization-select",
  styleUrls: ["./organization-select.component.scss"],
  templateUrl: "./organization-select.component.html",
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [Bind, Select, FormsModule],
})
export class OrganizationSelectComponent implements OnInit {
  private organizationRepository = inject(OrganizationRepository);

  public readonly organizationChange = output<Organization[]>();
  @Input() public organization: Organization = null;
  public readonly disabled = input(false);
  public readonly required = input(false);

  public subscription = new Subscription();
  public organizationList: SelectItem[] = [];
  public loaded = false;

  ngOnInit() {
    this.buildOrganizationList();
  }

  public onOrganizationChange(event: Organization[]) {
    this.organizationChange.emit(event);
  }

  private buildOrganizationList(): void {
    this.loaded = false;
    this.organizationList = [];

    this.organizationRepository.list().subscribe((organizationList) => {
      organizationList.forEach((organization) => {
        this.organizationList.push({
          label: organization.getName(),
          value: organization,
        });
      });
      this.loaded = true;
    });
  }
}
